import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import './UserManagement.scss';
import UserManagementInput from './UserManagementInput';
import UserManagementTable from './UserManagementTable';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import UserAnalytics from '../UserAnalytics/UserAnalytics';

const UserManagement: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    return (
        <>
            <Grid container>
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <UserManagementInput></UserManagementInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <UserManagementTable>
                    </UserManagementTable>
                </Grid>
            </Grid>
            <UserAnalytics></UserAnalytics>
        </>
    )
};

export default UserManagement;